module.exports = __webpack_public_path__ + "img/98bcf3fbd8ba25499a819330be1134d6.298e224e.png";